

















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class IndexPageFab extends Vue {
  @Prop() isShown!: boolean;
}
